import eventContentReducer from './events/eventContentReducer';
import eventTriggerReducer from './events/eventTriggerReducer';
import eventMediaReducer from './events/eventMediaReducer';
import eventAudioReducer from './events/eventAudioReducer';

/**
 * Subreducer for event-level actions, delegating to content, trigger, media, or audio subreducers.
 * @param {Object} state - current state of quests slice
 * @param {Object} action - dispatched Redux action
 * @returns {Object|null}
 */
export default function questEventsReducer(state, action) {
  const contentState = eventContentReducer(state, action);
  if (contentState) {
    return contentState;
  }

  const triggerState = eventTriggerReducer(state, action);
  if (triggerState) {
    return triggerState;
  }

  const mediaState = eventMediaReducer(state, action);
  if (mediaState) {
    return mediaState;
  }

  const audioState = eventAudioReducer(state, action);
  if (audioState) {
    return audioState;
  }

  return null;
}
